// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a1b100d1","667":"828917a0","977":"143688da"}[chunkId] + ".chunk.js";
};